import script from "./powerupLogin.vue?vue&type=script&setup=true&name=powerupLogin&lang=js"
export * from "./powerupLogin.vue?vue&type=script&setup=true&name=powerupLogin&lang=js"

const __exports__ = script;

export default __exports__